import { createValidator, ErrorObject, maxLength, required } from 'util/validation'
import { isEmpty } from 'util/validation/Util'

import { AtividadeColetivaGruposFormModel } from './model-atividadeColetivaGrupos'
import { isTipoGrupoReuniao, MSG_TIPO_GRUPO_REUNIAO_CIDADAOS_PARTICIPANTES } from './utils-atividadeColetivaGrupos'

export const atividadeColetivaGruposFormValidator = () =>
  createValidator<AtividadeColetivaGruposFormModel>(
    {
      nome: [required, maxLength(250)],
      tipoGrupo: [required],
    },
    (values: AtividadeColetivaGruposFormModel, errors: ErrorObject<AtividadeColetivaGruposFormModel>) => {
      if (isTipoGrupoReuniao(values?.tipoGrupo)) {
        errors.cidadaosParticipantes =
          !isEmpty(values?.cidadaosParticipantes) && MSG_TIPO_GRUPO_REUNIAO_CIDADAOS_PARTICIPANTES
      }

      return errors
    }
  )
